import { type BrowserTask, platformById } from "@ondit/publishing";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { readContent, studioKey } from "~/common/studio/api";
import { pick, useI18n, useT } from "~/core/i18n";
import { Async } from "~/core/ui/states";
import { PlatformComposer } from "./composer";

export function StudioPublishingTask({ entityId, task }: { entityId: string; task: BrowserTask }) {
	const { locale } = useI18n();
	const t = useT();
	const id = task.payload.source.content_id!;
	const item = useQuery({
		queryKey: [...studioKey(entityId), id],
		queryFn: () => readContent(entityId, id),
		refetchInterval: 5000,
	});
	const platform = platformById(task.payload.platform);
	return (
		<Async state={item}>
			{(content) =>
				platform && (
					<>
						<Link to={`/w/${entityId}/agent/home?studio=1&content=${encodeURIComponent(id)}`}>
							{pick(locale, ["Open source work", "打开素材母版"])}: {content.title}
						</Link>
						{content.revision !== task.payload.source.revision && (
							<p role="alert" className="banner banner-warn">
								{t("distribution.stale")}
							</p>
						)}
						<PlatformComposer
							key={task.id}
							entityId={entityId}
							platform={platform}
							source={{
								id,
								content_id: id,
								title: content.title,
								locale: content.locale,
								revision: task.payload.source.revision,
								canonical: "",
								blocks: [],
							}}
							initialTask={task}
							taskId={task.id}
							expandedPreview
							readOnly={content.revision !== task.payload.source.revision}
						/>
					</>
				)
			}
		</Async>
	);
}
